var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.12 72.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#82bff1;}.cls-1,.cls-3{stroke:#5a759c;}.cls-1,.cls-4,.cls-6,.cls-7{stroke-linejoin:round;}.cls-1,.cls-6{stroke-width:3.8px;}.cls-2,.cls-4{fill:#a9ca76;}.cls-3{fill:#fff;stroke-miterlimit:1;stroke-width:4.05px;}.cls-4,.cls-6,.cls-7{stroke:#5c8060;stroke-linecap:round;}.cls-4,.cls-7{stroke-width:3.8px;}.cls-5{fill:#c9e0a4;}.cls-6,.cls-7{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.9,27.68l29.63,8.91L70.22,15.8V12A10.11,10.11,0,0,0,60.11,1.9H12A10.11,10.11,0,0,0,1.9,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.9,27.68V60.11A10.11,10.11,0,0,0,12,70.22h48.1A10.11,10.11,0,0,0,70.22,60.11V48.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 21.13,
    cy: 17.31,
    r: 7.57
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "31.52 36.59 70.22 48.24 70.22 15.8 31.52 36.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.9,27.68v14q6.47.16,13.17.59a355.45,355.45,0,0,1,55.15,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.22,48.24,1.9,27.68V60.11A10.11,10.11,0,0,0,12,70.22h48.1A10.11,10.11,0,0,0,70.22,60.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.26,37.33a210.75,210.75,0,0,1,32.62-8.22c2.14-.36,4.25-.69,6.34-1V15.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "31.52 36.59 70.22 48.24 70.22 15.8 31.52 36.59"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.747b0b6cf39a7394335d46fb57b5465b.svg";
export { ForwardRef as ReactComponent };